import { isAiLimitType } from "@lingoshade/domain";

import i18n from "../config/i18n";

export interface ApiError {
  message: string;
  code?: string;
  status?: number;
}

interface AxiosLikeError {
  response?: {
    data?: { message?: string; code?: string };
    statusText?: string;
    status?: number;
  };
  message?: string;
  code?: string;
}

export function toApiError(error: unknown): ApiError {
  if (error && typeof error === "object") {
    const value = error as {
      code?: unknown;
      payload?: { limitType?: unknown };
      response?: { data?: { code?: unknown; limitType?: unknown } };
    };
    const code = value.response?.data?.code ?? value.code;
    if (typeof code === "string" && code.startsWith("PRONUNCIATION_"))
      return {
        code,
        message: i18n.t(`common:pronunciation.errors.${code}`, {
          defaultValue: i18n.t(
            "common:pronunciation.errors.PRONUNCIATION_UNAVAILABLE",
          ),
        }),
      };
    const limit = value.response?.data?.limitType ?? value.payload?.limitType;
    if (code === "AI_LIMIT_REACHED" && isAiLimitType(limit))
      return {
        code,
        status: limit === "ai_generation" ? 403 : 429,
        message: i18n.t(`common:aiPractice.limitMessages.${limit}`),
      };
  }
  if (error && typeof error === "object") {
    const e = error as AxiosLikeError;
    if (e.response) {
      return {
        message:
          e.response.data?.message ||
          e.response.statusText ||
          i18n.t("common:errors.networkError"),
        code: e.response.data?.code,
        status: e.response.status,
      };
    }
    if ("message" in e && typeof e.message === "string") {
      return {
        message: e.message,
        code: e.code,
        status:
          "status" in error && typeof error.status === "number"
            ? error.status
            : undefined,
      };
    }
  }
  return {
    message:
      typeof error === "string"
        ? error
        : i18n.t("common:interface.unknownErrorOccurred"),
  };
}

export function isApiError(error: unknown): error is ApiError {
  return (
    error !== null &&
    typeof error === "object" &&
    "message" in error &&
    typeof error.message === "string"
  );
}
